/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider-carousel-normail.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Setting - Carousel Slider - デフォルト
 */
const option = {
	// freeMode: true,
	loop: true,
	slidesPerView: 1,
	loopedSlides: 3,
	centeredSlides: true,
	spaceBetween: 20,
	// autoplay: {
	// 	delay: 2500,
	// 	disableOnInteraction: false,
	// },
	breakpoints: {
		// when window width is >= 320px
		768: {
			spaceBetween: 50,
		}
	}
};

/**
 * Action - Carousel Slider - デフォルト
 */
const sliderCarousel = new Swiper(".slider-carousel", option);